import findOverlappingBufferSegment from "utils/findOverlappingBufferSegment";

export default function findBufferedTimeRemaining(buffer, time) {
  const bufferSegment = findOverlappingBufferSegment(buffer, time);

  if (bufferSegment) {
    return bufferSegment.end - time;
  }

  return 0;
}
